
import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { DesktopNavigation } from "./Header/DesktopNavigation";
import { MobileNavigation } from "./Header/MobileNavigation";
import { useAuth } from "@/hooks/useAuth";

export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user } = useAuth();

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100 py-3">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <Link to="/inicio" className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-brand-primary flex items-center justify-center text-lg">
            ⚜️
          </div>
          <div>
            <span className="text-sm font-extrabold tracking-tight block leading-tight font-primary text-brand-primary">
              Clínica de Nutrição Equilíbrio
            </span>
            <span className="text-xs leading-none font-primary text-gray-400">
              Dra. Brenda Ramos CRN/3-63492
            </span>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <DesktopNavigation scrolled={true} />
        </div>

        <button
          className="md:hidden p-2 text-brand-primary"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <MobileNavigation isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
    </nav>
  );
}
